// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"1f5e9016","291":"ac67afbc","399":"ad124032","450":"b560aa20","614":"8a80d725"}[chunkId] + ".chunk.js";
};